import { convertToNumber } from "./numberHelper";

type MobileOsName = "iOS" | "Android";

declare global {
  interface Window {
    opera: string;
    MSStream: string;
  }
}

/**
 * Returns mobile OS name ("iOS" | "Android"), or undefined if not a mobile OS
 */
export const getMobileOs = (): MobileOsName | undefined => {
  const userAgent = navigator.userAgent || window.opera;

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return undefined;
};

/**
 * Returns Safari major version, or undefined if not Safari.
 */
export const getSafariMajorVersion = (): number | undefined => {
  const match = navigator.userAgent.match(/Version\/(\d+)\.\d+.*Safari/);
  return convertToNumber(match?.[1]);
};

export const isSafari = (): boolean => getSafariMajorVersion() !== undefined;
